<template>
  <div class="logs_datatable">
    <datatable
        :type="'activity'"
        :recordType="'worker'"
        :rowData="logs"
        :heightStyle="'height: calc(100vh - 190px);'"
        :loadingMessage="loadingMessage"
        :noRowsMessage="noRowsMessage"
        :columns="columns"
    ></datatable>

    <!-- DIFF MODAL -->
    <b-modal
        v-model="showDiffModal"
        title="Change Details"
        hide-footer
        size="lg"
    >
      <div v-if="Object.keys(diffData).length === 0">
        <p class="text-muted text-center mb-0">No field changes detected</p>
      </div>

      <table v-else class="table table-sm diff-table">
        <thead>
        <tr>
          <th style="width: 180px">Field</th>
          <th>Before</th>
          <th>After</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(v, key) in diffData" :key="key">
          <td class="font-weight-bold">{{ key }}</td>

          <td :class="{ 'text-danger': v.before !== v.after }">
            <pre class="diff-block">{{ formatValue(v.before) }}</pre>
          </td>

          <td :class="{ 'text-success font-weight-bold': v.before !== v.after }">
            <pre class="diff-block">{{ formatValue(v.after) }}</pre>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="text-right mt-3">
        <button class="btn btn-secondary btn-sm" @click="closeModal">Close</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: "logs",
  components: { datatable },
  props: ["logs", "logsLoaded"],

  data() {
    return {
      loadingMessage: "Loading Activity Logs...",
      noRowsMessage: "No Logs Found",
      showDiffModal: false,
      diffData: {},

      columns: [
        { headerName: "Time", valueGetter: this.activity_time_value_getter, width: 80 },
        { headerName: "User", valueGetter: this.user_value_getter, width: 100 },
        { headerName: "Action", valueGetter: this.activity_type_value_getter, width: 75 },
        { headerName: "Note", valueGetter: this.note_value_getter, width: 300 },
        { headerName: "Target", valueGetter: this.record_type_value_getter, width: 75 },
        { headerName: "Changes", cellRenderer: this.change_button_renderer, width: 75 }
      ]
    };
  },

  methods: {
    note_value_getter(params) {
      const row = params.data || {};

      if (!this.is_note_log(row)) {
        return "";
      }

      return this.clean_note_text(
          (row.new_values && row.new_values.note) ||
          (row.old_values && row.old_values.note) ||
          ""
      );
    },

    is_note_log(row) {
      return row.record_scope === "note" ||
          row.record_model_type === "App\\Models\\Notes\\Note";
    },

    clean_note_text(value) {
      if (!value) {
        return "";
      }

      return String(value)
          .replace(/\s+/g, " ")
          .trim();
    },

    activity_type_value_getter(params) {
      const row = params.data || {};
      const type = row.type;

      if (!type) {
        return "";
      }

      return this.$options.filters.capitalWords(type);
    },

    record_type_value_getter(params) {
      const row = params.data || {};

      if (row.record_scope === "note") {
        return "Note";
      }

      if (row.record_model_type) {
        return this.$options.filters.modelLog(row.record_model_type);
      }

      if (row.record_scope) {
        return this.$options.filters.capitalWords(row.record_scope);
      }

      return "";
    },

    user_value_getter(params) {
      const row = params.data || {};
      return row.user_name || "System";
    },

    activity_time_value_getter(params) {
      const row = params.data || {};
      const createdAt = row.created_at || row.updated_at;

      if (!createdAt) {
        return "";
      }

      return this.$options.filters.formatDateTime(createdAt);
    },

    change_button_renderer(params) {
      const row = params.data || {};

      if (!row.old_values && !row.new_values) {
        return "";
      }

      const btn = document.createElement("button");
      btn.innerText = "View";
      btn.classList.add("btn", "orcaBtn", "btn-sm", "btn-outline-primary");
      btn.onclick = () => this.openDiff(row);

      return btn;
    },

    openDiff(row) {
      const before = row.old_values || {};
      const after = row.new_values || {};

      const diff = {};
      const fields = new Set([
        ...Object.keys(before),
        ...Object.keys(after)
      ]);

      fields.forEach(key => {
        const beforeValue = before[key] === undefined ? null : before[key];
        const afterValue = after[key] === undefined ? null : after[key];

        if (JSON.stringify(beforeValue) !== JSON.stringify(afterValue)) {
          diff[key] = {
            before: beforeValue,
            after: afterValue
          };
        }
      });

      this.diffData = diff;
      this.showDiffModal = true;
    },

    formatValue(val) {
      if (val === null || val === undefined || val === "") {
        return "-";
      }

      if (typeof val === "object") {
        return JSON.stringify(val, null, 2);
      }

      return String(val);
    },

    closeModal() {
      this.showDiffModal = false;
    }
  }
};
</script>

<style scoped lang="scss">
.logs_datatable {
  .full_height_datatable {
    height: calc(100vh - 185px);
  }
}

.diff-block {
  white-space: pre-wrap !important;
  font-size: 0.75rem;
  background: #f9f9f9;
  padding: 4px;
  border-radius: 4px;
}

.diff-table td {
  vertical-align: top !important;
}
</style>